import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "45px",
  height: "45px",
  viewBox: "0 0 45 45",
  style: {"enable-background":"new 0 0 45 45"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:none}.__st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.__st2{fill:#231F20}.__st3{fill:#121319}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"__Group_1748_1_\" transform=\"translate(15147.046 -258)\"><g id=\"__Group_1698_1_\" transform=\"translate(-13934.786 157.475)\"><path d=\"M-1200.3,137.27l-8.32-12.71l8.99-6.5l0.87-4.25l9.81-4.87l7.47,10.11l-8.92,6.85l2.05,2.82L-1200.3,137.27z\r\n\t\t\t M-1205.9,125.06l6.13,9.37l8.62-6.17l-2.01-2.77l8.91-6.84l-5.3-7.18l-7.44,3.69l-0.83,4.06L-1205.9,125.06z\"></path><path d=\"M-1191.29,121.8c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82c2.11,0,3.82,1.71,3.82,3.82\r\n\t\t\tS-1189.18,121.8-1191.29,121.8z M-1191.29,116.16c-1,0-1.82,0.82-1.82,1.82c0,1,0.82,1.82,1.82,1.82s1.82-0.82,1.82-1.82\r\n\t\t\tC-1189.47,116.97-1190.29,116.16-1191.29,116.16z\"></path><path d=\"M-1184.74,131.8l-4.19-5.76l17.16-12.94l0.55,8.18L-1184.74,131.8z M-1186.16,126.45l1.82,2.5l11.04-8.6l-0.23-3.43\r\n\t\t\tL-1186.16,126.45z\"></path></g></g>", 1))
  ]))
}
export default { render: render }